import { create } from "zustand";

export type Theme = "auto" | "light" | "dark";

export interface LockedOverlayState {
  reason: "idle" | "manual";
  returnTo: string;
}

interface UiState {
  theme: Theme;
  sidebarCollapsed: boolean;
  drawerOpen: boolean;
  lockedOverlay: LockedOverlayState | null;
  autoLockMinutes: number;
  /**
   * Session-scoped flag tracking whether the user dismissed the
   * pending-rotation banner. Re-shown on next session (app reload)
   * as long as any vault still has `pending_rotation` set. No
   * persistence — `useUi` is in-memory only by design.
   */
  pendingRotationBannerDismissed: boolean;
  setTheme: (t: Theme) => void;
  toggleSidebar: () => void;
  setDrawerOpen: (open: boolean) => void;
  showLockedOverlay: (state: LockedOverlayState) => void;
  hideLockedOverlay: () => void;
  setAutoLockMinutes: (n: number) => void;
  dismissPendingRotationBanner: () => void;
}

export const useUi = create<UiState>((set) => ({
  theme: "auto",
  sidebarCollapsed: false,
  drawerOpen: false,
  lockedOverlay: null,
  autoLockMinutes: 5,
  pendingRotationBannerDismissed: false,
  setTheme: (theme) => set({ theme }),
  toggleSidebar: () =>
    set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setDrawerOpen: (drawerOpen) => set({ drawerOpen }),
  showLockedOverlay: (lockedOverlay) => set({ lockedOverlay }),
  hideLockedOverlay: () => set({ lockedOverlay: null }),
  setAutoLockMinutes: (autoLockMinutes) => set({ autoLockMinutes }),
  dismissPendingRotationBanner: () =>
    set({ pendingRotationBannerDismissed: true }),
}));
